export const FILE_STATUS = {
    1: { name: "Missing", background: "danger" },
    2: { name: "In Progress", background: "warning" },
    3: { name: "Completed", background: "success" },
    4: { name: "Failed", background: "danger" },
}